@if (isMobile) {
  <app-short-search-params-mobile />
} @else {
  <app-short-search-params-desktop />
}
